// useNeoAuth0.js
import { useAuth0 } from "@auth0/auth0-react";
import { NeoAuth0Context } from "./neoAuth0Context";

export const useNeoAuth0 = () =>
  useAuth0(NeoAuth0Context);
